
  import { Component, Prop, Vue } from 'vue-property-decorator'
  import { QLayout, QPage, QPageContainer } from 'quasar'
  // @ts-ignore
  // noinspection TypeScriptCheckImport
  import { MapViewer } from '@parantion/components'

  @Component({
    components: {
      MapViewer,
      QLayout,
      QPageContainer,
      QPage
    }
  })


  export default class Map extends Vue {
    @Prop()
    expanded

    center = { lat: 52.1326, lng: 5.2913 }

    get markers() {
      const markers = this.$store.getters['directus/getMapMarkers']
      return markers ? markers.markers : []
    }

    get infoLabel() {
      const markers = this.$store.getters['directus/getMapMarkers']
      return markers ? markers.mapInfoLabel : ''
    }

    get kml() {
      return this.$store.state.directus.kmlFile
    }

    clustering = false
    customIcon = {
      path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      fillColor: 'white',
      fillOpacity: 1,
      strokeColor: '#0C5E89',
      strokeWeight: 2,
      scale: 0.8,
      labelOrigin: { x: 0, y: -30 }
    }
    zoom = 6
    sideView = false

    setView(value) {
      this.sideView = value
    }
  }
